import { useState } from "react";
import { Helmet } from "react-helmet";
import BackButton from "../components/BackButton";

export default function JsonFormatter() {
  const [input, setInput] = useState("");
  const [output, setOutput] = useState("");
  const [error, setError] = useState("");

  const tryFixJSON = (str) => {
    try {
      // Try as full JSON first
      return JSON.stringify(JSON.parse(str), null, 2);
    } catch {
      try {
        // Try fixing multiple objects/arrays by wrapping in array
        const wrapped = `[${str
          .trim()
          .replace(/}\s*{/g, "},\n{")
          .replace(/]\s*\[/g, "],\n[")}]`;
        return JSON.stringify(JSON.parse(wrapped), null, 2);
      } catch (err) {
        throw err;
      }
    }
  };

  const formatJSON = () => {
    try {
      const formatted = tryFixJSON(input);
      setOutput(formatted);
      setError("");
    } catch (err) {
      setError("❌ Invalid JSON: " + err.message);
      setOutput("");
    }
  };

  const copyOutput = () => {
    navigator.clipboard.writeText(output);
    alert("✅ Formatted JSON copied!");
  };

  return (
    <>
      <Helmet>
        <title>JSON Formatter & Validator - Free Online Tool to Beautify & Validate JSON</title>
        <meta
          name="description"
          content="Advanced JSON Formatter and Validator. Beautify, validate, and fix errors in your JSON data online. Free tool for flawless JSON formatting."
        />
        <meta name="keywords" content="json formatter, json validator, validate json, beautify json, json error fixer, free json tool, online json formatter" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://freelity.com/json-formatter" />
      </Helmet>

      <section className="sec-free-tools">
        <div className="container">
          <BackButton />
          <h2>JSON Formatter & Validator</h2>

          <textarea
            rows="10"
            className="form-control mb-3"
            placeholder="Paste your JSON here..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
          />

          <button className="btn btn-primary mb-3" onClick={formatJSON}>
            Format JSON
          </button>

          {error && <div className="alert alert-danger">{error}</div>}

          {output && (
            <>
              <h5>✅ Formatted JSON:</h5>
              <textarea
                rows="10"
                className="form-control mb-3"
                value={output}
                readOnly
              />
              <button className="btn btn-success bigsize" onClick={copyOutput}>
                Copy Formatted JSON
              </button>
            </>
          )}
        </div>
      </section>
    </>
  );
}
